import { AssetTypes } from "@zapier/utils";

export function convertToAssetId(
  assetType: AssetTypes,
  assetId: string | number | undefined,
) {
  if (typeof assetId !== "string" && typeof assetId !== "number") {
    return "";
  }

  if (assetId.toString().includes(":")) {
    return String(assetId);
  }
  return `${assetType}:${assetId}`;
}
